import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Check if user is already logged in (from localStorage) on mount
  useEffect(() => {
    const storedAuth = localStorage.getItem('isAuthenticated');
    const storedEmail = localStorage.getItem('userEmail');

    if (storedAuth === 'true' && storedEmail) {
      setIsAuthenticated(true);
      setUserEmail(storedEmail);
    }

    setIsLoading(false);
  }, []);

  const recordLoginHistory = (email) => {
    try {
      let loginHistory = JSON.parse(localStorage.getItem('loginHistory') || '{}');

      if (!loginHistory[email]) {
        loginHistory[email] = {
          email,
          loginCount: 0,
          lastLoginTime: null,
          loginTimestamps: []
        };
      }

      loginHistory[email].loginCount += 1;
      loginHistory[email].lastLoginTime = new Date().toISOString();
      loginHistory[email].loginTimestamps.push(new Date().toISOString());

      localStorage.setItem('loginHistory', JSON.stringify(loginHistory));
    } catch (error) {
      console.error('Error recording login history:', error);
    }
  };

  const login = (email) => {
    setIsAuthenticated(true);
    setUserEmail(email);
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('userEmail', email);
    recordLoginHistory(email);
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUserEmail(null);
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userEmail');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, userEmail, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
